import { API } from "@/services"

export const IPMI_SERVERS_ENDPOINTS = {
  create(data={}){
    return API.Axios.error_capture.v1.request({
      url: `ipmi-servers`,
      method: 'POST',
      data,
    })
  },
  list(params={}){
    return API.Axios.error_capture.v1.request({
      url: `ipmi-servers`,
      method: 'GET',
      params,
    })
  },
  findById(id,params={}){
    return API.Axios.error_capture.v1.request({
      url: `ipmi-servers/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `ipmi-servers/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `ipmi-servers/${id}`,
      method: 'PUT',
      data,
    })
  },
  powerOn(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `ipmi-servers/${id}/power/on`,
      method: 'PATCH',
      data,
    })
  },
  powerOff(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `ipmi-servers/${id}/power/off`,
      method: 'PATCH',
      data,
    })
  },
  uidOn(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `ipmi-servers/${id}/uid/on`,
      method: 'PATCH',
      data,
    })
  },
  uidOff(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `ipmi-servers/${id}/uid/off`,
      method: 'PATCH',
      data,
    })
  },
}